<div class="d-sm-flex pb-3 border-gray-200 border-bottom">
  <div class="flex-grow-1 me-3">
    <h4>
      <a
        [appSearchResultLink]="result"
        [href]="result.url">{{ result.title }}</a>
    </h4>
    <div class="d-flex flex-wrap small mb-2">
      @for (crumb of crumbs | truthy; track crumb) {
        <app-crumb
          [label]="crumb"
          [bold]="false"></app-crumb>
        <span class="d-none-first-or-last mx-1"><i class="vr"></i></span>
      }
    </div>
    <div>
      <ng-content></ng-content>
    </div>
  </div>
  @if (result.thumbnailUrl) {
    <div
      class="d-flex align-items-start mt-3 mt-sm-0"
    >
      @if (result.thumbnailUrl) {
        <div
          class="position-relative w-100 mb-3 mb-sm-0"
        >
          @if (result.mediaType === MediaType.VIDEO) {
            <div
              class="card-img-overlay d-flex align-items-center"
            >
              <a
                class="stretched-link play-button display-4 mx-auto"
                [href]="result.url">
                <span class="material-symbols-outlined">play_circle</span>
              </a>
            </div>
          }
          <img
            [src]="result.thumbnailUrl"
            [alt]="result.title">
        </div>
      }
    </div>
  }
</div>
